import { AcceptedCurrencyModel } from '../../models/currencies';

export enum ContractAddressesMainnetEnum {
  ETH = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  DAI = '0xf80A32A835F79D7787E8a8ee5721D0fEaFd78108',
  USDT = '0xB404c51BBC10dcBE948077F18a4B8E553D160084',
  WBTC = '0xa0E54Ab6AA5f0bf1D62EC3526436F3c05b3348A0',
}

export const contractChainlinkMainnet =
  '0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419';
export const predomainHelperMainnet =
  '0x3B0853809198a9b6748712c70871B1Ff6F4cff91';

export const acceptedCurrenciesMainnet = [] as AcceptedCurrencyModel[];
